import zbproject from './zbproject';
import zbprojectpermission from './zbprojectpermission';

export default {
    path: 'zbr',
    component: () => import('@layout/empty'),
    children: [
        zbproject,
        zbprojectpermission
      
    ]
}
